import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import React from 'react';
import classNames from 'classnames/bind';
import styles from './DraggableFlatList.scss';

const cx = classNames.bind(styles);

function DraggableFlatList({
  type = 'image',
  list = [],
  onSelect,
  onChange,
  selected,
  showNumbering = true,
  renderAddButton,
  className,
}) {
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(list);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    onChange(items);
  };

  return (
    <div className={cx('DraggableFlatList', className)}>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="list">
          {(provided) => (
            <ul className={cx('list')} {...provided.droppableProps} ref={provided.innerRef}>
              {list.map((item, index) => {
                const id = item;
                const selectedId = String(selected);
                return (
                  <Draggable key={id} draggableId={id} index={index}>
                    {(provided) => (
                      <li
                        className={cx(selectedId === id && 'selected')}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {showNumbering && <span>{index + 1}</span>}
                        <img
                          className={cx(selectedId === id && 'selected')}
                          onClick={() => onSelect(item)}
                          src={`${item}?w=500&f=jpeg`}
                          alt={`item-${id}`}
                        />
                      </li>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
              {renderAddButton ? renderAddButton() : null}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

export default DraggableFlatList;
